import { displayFormModal } from '@helpers/displayFormModalState';
import { ComponentTheme } from '@helpers/themeEnum';
import React from 'react';
import { FocusRing } from 'react-aria';
import { ButtonStyles } from './Button.styles';
const Button = ({ addon, addonPosition = 'left', backgroundPlacement = 'light', branding, buttonSize = 'large', className, disabled, hasShadow, styleType, title, type = 'button', onClick, ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(ButtonStyles.Button, { className: className, "data-branding": defineButtonBranding(branding, styleType), "data-button-size": buttonSize, "data-background-placement": backgroundPlacement, "data-shadow": hasShadow, disabled: disabled, "data-style-type": styleType, styleType: styleType, iconPosition: addonPosition, type: type, onClick: onClick, ...otherProps },
            React.createElement(ButtonStyles.ButtonInner, null,
                addon && addonPosition === 'left' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon)),
                React.createElement(ButtonStyles.Text, null, title),
                addon && addonPosition === 'right' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon))))));
};
const LinkButton = ({ addon, addonPosition = 'left', backgroundPlacement = 'light', branding, buttonSize = 'large', className, download, hasShadow, href, styleType, target = '_self', title, }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(ButtonStyles.Button, { className: className, as: "a", "data-branding": defineButtonBranding(branding, styleType), "data-button-size": buttonSize, "data-background-placement": backgroundPlacement, "data-shadow": hasShadow, download: download, href: href, "data-style-type": styleType, styleType: styleType, target: target, onClick: (e) => {
                if (href === '#' || href === undefined) {
                    e.preventDefault();
                    displayFormModal(true);
                }
                else if (href) {
                    return;
                }
            } },
            React.createElement(ButtonStyles.ButtonInner, null,
                addon && addonPosition === 'left' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon)),
                React.createElement(ButtonStyles.Text, null, title),
                addon && addonPosition === 'right' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon))))));
};
const FakeButton = ({ addon, addonPosition = 'left', backgroundPlacement = 'light', branding, buttonSize = 'large', className, hasShadow, styleType, title, }) => {
    return (React.createElement(ButtonStyles.Button, { className: className, as: "div", "data-branding": defineButtonBranding(branding, styleType), "data-button-size": buttonSize, "data-background-placement": backgroundPlacement, "data-shadow": hasShadow, "data-style-type": styleType, styleType: styleType },
        React.createElement(ButtonStyles.ButtonInner, null,
            addon && addonPosition === 'left' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon)),
            React.createElement(ButtonStyles.Text, null, title),
            addon && addonPosition === 'right' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon)))));
};
const GetInTouchButton = ({ addon, addonPosition = 'left', backgroundPlacement = 'light', branding, buttonSize = 'large', className, download, hasShadow, href, styleType = 'pill', target = '_self', title, onClick, }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(ButtonStyles.Button, { className: className, as: href ? 'a' : 'button', "data-branding": styleType === 'pill' || styleType === 'square'
                ? branding === 'orange'
                    ? branding
                    : undefined
                : branding ?? 'blue', "data-button-size": buttonSize, "data-background-placement": backgroundPlacement, "data-shadow": hasShadow, "data-get-in-touch": true, download: download, href: href, onClick: (e) => {
                if (onClick) {
                    onClick(e);
                }
                else if (href === '#' || href === undefined || !href) {
                    e.preventDefault();
                    displayFormModal(true);
                }
                else if (href) {
                    return;
                }
            }, "data-style-type": styleType, styleType: styleType, target: target },
            React.createElement(ButtonStyles.ButtonInner, null,
                addon && addonPosition === 'left' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon)),
                React.createElement(ButtonStyles.Text, null, title),
                addon && addonPosition === 'right' && (React.createElement(ButtonStyles.Icon, { position: addonPosition }, addon))))));
};
const PILL_BRANDING_COLOURS = [ComponentTheme.Orange];
function defineButtonBranding(branding, styleType) {
    return styleType === 'pill' || styleType === 'square'
        ? branding && PILL_BRANDING_COLOURS.includes(branding)
            ? branding
            : undefined
        : branding ?? 'blue';
}
export { Button, Button as default, FakeButton, GetInTouchButton, LinkButton };
